/** "What the preview can’t show": a disclosure under a preview listing what it leaves out —
 *  each limit a bold lead and its reason. Closed by default; one tab stop. Shared by the
 *  tour's phone preview and the operator's guest-form preview. */
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, ButtonBase, Typography } from '@mui/material';
import { useId, useState } from 'react';

/** What a preview never shows: what (the lead), and why. */
export interface PreviewLimit {
  lead: string;
  reason: string;
}

export function PreviewLimitsDisclosure({ limits }: { limits: readonly PreviewLimit[] }) {
  const [open, setOpen] = useState(false);
  const listId = useId();
  return (
    <>
      <ButtonBase
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={listId}
        data-preview-limits
        sx={{
          justifySelf: 'start',
          gap: 0.5,
          borderRadius: 0.5,
          typography: 'caption',
          color: 'primary.main',
          fontWeight: 600,
          '&.Mui-focusVisible': { boxShadow: (t) => `0 0 0 2px ${t.palette.primary.main}` },
        }}
      >
        {open ? <ExpandLessIcon aria-hidden sx={{ fontSize: 16 }} /> : <ExpandMoreIcon aria-hidden sx={{ fontSize: 16 }} />}
        What the preview can’t show
      </ButtonBase>
      {open && (
        <Box component="ul" id={listId} sx={{ m: 0, pl: 2.5, display: 'grid', gap: 0.5 }}>
          {limits.map((l) => (
            <Typography key={l.lead} component="li" variant="caption" color="text.secondary" data-preview-limit>
              <Box component="strong" sx={{ color: 'text.primary', fontWeight: 600 }}>
                {l.lead}
              </Box>
              {' — '}
              {l.reason}
            </Typography>
          ))}
        </Box>
      )}
    </>
  );
}
